document.addEventListener("DOMContentLoaded", function () {
  var dataScript = document.querySelector('script.tg-faq-data[type="application/json"]');

  if (!dataScript) {
    console.warn("[tg-faq] FAQ data missing");
    return;
  }

  var raw = (dataScript.textContent || "").trim();

  if (!raw) {
    console.warn("[tg-faq] FAQ data is empty");
    return;
  }

  var items;

  try {
    items = JSON.parse(raw);
  } catch (e) {
    console.warn("[tg-faq] Unable to parse FAQ data", e);
    return;
  }

  if (!Array.isArray(items) || !items.length) {
    return;
  }

  var faqElement = dataScript.previousElementSibling;

  if (!faqElement || faqElement.tagName.toLowerCase() !== "dbtfy-faq") {
    return;
  }

  var wrapper = faqElement.querySelector(".dbtfy-faq-group-wrapper");

  if (!wrapper) {
    return;
  }

  var template = wrapper.querySelector(".tg-faq-template");

  if (!template || !("content" in template)) {
    return;
  }

  items.forEach(function (item, index) {
    var fragment = template.content.cloneNode(true);
    var questionWrapper = fragment.querySelector(".dbtfy-faq-question-wrapper");

    if (!questionWrapper) {
      return;
    }

    if (index === 0) {
      questionWrapper.classList.add("dbtfy-faq-active");
    }

    var questionEl = fragment.querySelector(".dbtfy-faq-question");

    if (questionEl) {
      questionEl.textContent = item.title || "";
    }

    var answerEl = fragment.querySelector(".dbtfy-faq-answer-block .rte");

    if (answerEl) {
      answerEl.innerHTML = item.content;
    }

    var questionBlock = fragment.querySelector(".dbtfy-faq-question-block") || questionWrapper;

    questionBlock.addEventListener("click", function () {
      questionWrapper.classList.toggle("dbtfy-faq-active");
    });

    wrapper.appendChild(fragment);
  });

  // Schema.org FAQPage
  var ld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(function (item) {
      var title = item.title || "";
      title = title.replace(/<[^>]+>/g, "");

      return {
        "@type": "Question",
        "name": title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.content
        }
      };
    })
  };

  var ldScript = document.createElement("script");
  ldScript.type = "application/ld+json";
  ldScript.text = JSON.stringify(ld);
  document.head.appendChild(ldScript);
});
